/**
 * @fileoverview gRPC-Web generated client stub for pi_customer_public
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wt/svc/customer/user_team.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as wt_svc_customer_user_team_pb from '../../../wt/svc/customer/user_team_pb';


export class UserTeamServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/CreateTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.CreateTeamRequest,
    wt_svc_customer_user_team_pb.CreateTeamResponse,
    (request: wt_svc_customer_user_team_pb.CreateTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.CreateTeamResponse.deserializeBinary
  );

  createTeam(
    request: wt_svc_customer_user_team_pb.CreateTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.CreateTeamResponse>;

  createTeam(
    request: wt_svc_customer_user_team_pb.CreateTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CreateTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.CreateTeamResponse>;

  createTeam(
    request: wt_svc_customer_user_team_pb.CreateTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CreateTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/CreateTeam',
        request,
        metadata || {},
        this.methodDescriptorCreateTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/CreateTeam',
    request,
    metadata || {},
    this.methodDescriptorCreateTeam);
  }

  methodDescriptorGetTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/GetTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.GetTeamRequest,
    wt_svc_customer_user_team_pb.GetTeamResponse,
    (request: wt_svc_customer_user_team_pb.GetTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.GetTeamResponse.deserializeBinary
  );

  getTeam(
    request: wt_svc_customer_user_team_pb.GetTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.GetTeamResponse>;

  getTeam(
    request: wt_svc_customer_user_team_pb.GetTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.GetTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.GetTeamResponse>;

  getTeam(
    request: wt_svc_customer_user_team_pb.GetTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.GetTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/GetTeam',
        request,
        metadata || {},
        this.methodDescriptorGetTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/GetTeam',
    request,
    metadata || {},
    this.methodDescriptorGetTeam);
  }

  methodDescriptorGetMyTeams = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/GetMyTeams',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.GetMyTeamsRequest,
    wt_svc_customer_user_team_pb.GetMyTeamsResponse,
    (request: wt_svc_customer_user_team_pb.GetMyTeamsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.GetMyTeamsResponse.deserializeBinary
  );

  getMyTeams(
    request: wt_svc_customer_user_team_pb.GetMyTeamsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.GetMyTeamsResponse>;

  getMyTeams(
    request: wt_svc_customer_user_team_pb.GetMyTeamsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.GetMyTeamsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.GetMyTeamsResponse>;

  getMyTeams(
    request: wt_svc_customer_user_team_pb.GetMyTeamsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.GetMyTeamsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/GetMyTeams',
        request,
        metadata || {},
        this.methodDescriptorGetMyTeams,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/GetMyTeams',
    request,
    metadata || {},
    this.methodDescriptorGetMyTeams);
  }

  methodDescriptorUpdateTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UpdateTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UpdateTeamRequest,
    wt_svc_customer_user_team_pb.UpdateTeamResponse,
    (request: wt_svc_customer_user_team_pb.UpdateTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UpdateTeamResponse.deserializeBinary
  );

  updateTeam(
    request: wt_svc_customer_user_team_pb.UpdateTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UpdateTeamResponse>;

  updateTeam(
    request: wt_svc_customer_user_team_pb.UpdateTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UpdateTeamResponse>;

  updateTeam(
    request: wt_svc_customer_user_team_pb.UpdateTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UpdateTeam',
        request,
        metadata || {},
        this.methodDescriptorUpdateTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UpdateTeam',
    request,
    metadata || {},
    this.methodDescriptorUpdateTeam);
  }

  methodDescriptorUpdateTeamName = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UpdateTeamName',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UpdateTeamNameRequest,
    wt_svc_customer_user_team_pb.UpdateTeamNameResponse,
    (request: wt_svc_customer_user_team_pb.UpdateTeamNameRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UpdateTeamNameResponse.deserializeBinary
  );

  updateTeamName(
    request: wt_svc_customer_user_team_pb.UpdateTeamNameRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UpdateTeamNameResponse>;

  updateTeamName(
    request: wt_svc_customer_user_team_pb.UpdateTeamNameRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamNameResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UpdateTeamNameResponse>;

  updateTeamName(
    request: wt_svc_customer_user_team_pb.UpdateTeamNameRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamNameResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UpdateTeamName',
        request,
        metadata || {},
        this.methodDescriptorUpdateTeamName,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UpdateTeamName',
    request,
    metadata || {},
    this.methodDescriptorUpdateTeamName);
  }

  methodDescriptorUploadTeamLogo = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UploadTeamLogo',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UploadTeamLogoRequest,
    wt_svc_customer_user_team_pb.UploadTeamLogoResponse,
    (request: wt_svc_customer_user_team_pb.UploadTeamLogoRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UploadTeamLogoResponse.deserializeBinary
  );

  uploadTeamLogo(
    request: wt_svc_customer_user_team_pb.UploadTeamLogoRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UploadTeamLogoResponse>;

  uploadTeamLogo(
    request: wt_svc_customer_user_team_pb.UploadTeamLogoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UploadTeamLogoResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UploadTeamLogoResponse>;

  uploadTeamLogo(
    request: wt_svc_customer_user_team_pb.UploadTeamLogoRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UploadTeamLogoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UploadTeamLogo',
        request,
        metadata || {},
        this.methodDescriptorUploadTeamLogo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UploadTeamLogo',
    request,
    metadata || {},
    this.methodDescriptorUploadTeamLogo);
  }

  methodDescriptorSetTeamRoundingPreference = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/SetTeamRoundingPreference',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceRequest,
    wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse,
    (request: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse.deserializeBinary
  );

  setTeamRoundingPreference(
    request: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse>;

  setTeamRoundingPreference(
    request: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse>;

  setTeamRoundingPreference(
    request: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SetTeamRoundingPreferenceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/SetTeamRoundingPreference',
        request,
        metadata || {},
        this.methodDescriptorSetTeamRoundingPreference,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/SetTeamRoundingPreference',
    request,
    metadata || {},
    this.methodDescriptorSetTeamRoundingPreference);
  }

  methodDescriptorSetDirectTimelinePostPreference = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/SetDirectTimelinePostPreference',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceRequest,
    wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse,
    (request: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse.deserializeBinary
  );

  setDirectTimelinePostPreference(
    request: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse>;

  setDirectTimelinePostPreference(
    request: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse>;

  setDirectTimelinePostPreference(
    request: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SetDirectTimelinePostPreferenceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/SetDirectTimelinePostPreference',
        request,
        metadata || {},
        this.methodDescriptorSetDirectTimelinePostPreference,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/SetDirectTimelinePostPreference',
    request,
    metadata || {},
    this.methodDescriptorSetDirectTimelinePostPreference);
  }

  methodDescriptorDeleteTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/DeleteTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.DeleteTeamRequest,
    wt_svc_customer_user_team_pb.DeleteTeamResponse,
    (request: wt_svc_customer_user_team_pb.DeleteTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.DeleteTeamResponse.deserializeBinary
  );

  deleteTeam(
    request: wt_svc_customer_user_team_pb.DeleteTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.DeleteTeamResponse>;

  deleteTeam(
    request: wt_svc_customer_user_team_pb.DeleteTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeleteTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.DeleteTeamResponse>;

  deleteTeam(
    request: wt_svc_customer_user_team_pb.DeleteTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeleteTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/DeleteTeam',
        request,
        metadata || {},
        this.methodDescriptorDeleteTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/DeleteTeam',
    request,
    metadata || {},
    this.methodDescriptorDeleteTeam);
  }

  methodDescriptorListTeamInvitations = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ListTeamInvitations',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ListTeamInvitationsRequest,
    wt_svc_customer_user_team_pb.ListTeamInvitationsResponse,
    (request: wt_svc_customer_user_team_pb.ListTeamInvitationsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ListTeamInvitationsResponse.deserializeBinary
  );

  listTeamInvitations(
    request: wt_svc_customer_user_team_pb.ListTeamInvitationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ListTeamInvitationsResponse>;

  listTeamInvitations(
    request: wt_svc_customer_user_team_pb.ListTeamInvitationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamInvitationsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ListTeamInvitationsResponse>;

  listTeamInvitations(
    request: wt_svc_customer_user_team_pb.ListTeamInvitationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamInvitationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ListTeamInvitations',
        request,
        metadata || {},
        this.methodDescriptorListTeamInvitations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ListTeamInvitations',
    request,
    metadata || {},
    this.methodDescriptorListTeamInvitations);
  }

  methodDescriptorInviteUsers = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/InviteUsers',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.InviteUsersRequest,
    wt_svc_customer_user_team_pb.InviteUsersResponse,
    (request: wt_svc_customer_user_team_pb.InviteUsersRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.InviteUsersResponse.deserializeBinary
  );

  inviteUsers(
    request: wt_svc_customer_user_team_pb.InviteUsersRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.InviteUsersResponse>;

  inviteUsers(
    request: wt_svc_customer_user_team_pb.InviteUsersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.InviteUsersResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.InviteUsersResponse>;

  inviteUsers(
    request: wt_svc_customer_user_team_pb.InviteUsersRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.InviteUsersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/InviteUsers',
        request,
        metadata || {},
        this.methodDescriptorInviteUsers,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/InviteUsers',
    request,
    metadata || {},
    this.methodDescriptorInviteUsers);
  }

  methodDescriptorAcceptTeamJoinInvite = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/AcceptTeamJoinInvite',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.AcceptTeamJoinInviteRequest,
    wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse,
    (request: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse.deserializeBinary
  );

  acceptTeamJoinInvite(
    request: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse>;

  acceptTeamJoinInvite(
    request: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse>;

  acceptTeamJoinInvite(
    request: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.AcceptTeamJoinInviteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/AcceptTeamJoinInvite',
        request,
        metadata || {},
        this.methodDescriptorAcceptTeamJoinInvite,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/AcceptTeamJoinInvite',
    request,
    metadata || {},
    this.methodDescriptorAcceptTeamJoinInvite);
  }

  methodDescriptorResendInvitation = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ResendInvitation',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ResendInvitationRequest,
    wt_svc_customer_user_team_pb.ResendInvitationResponse,
    (request: wt_svc_customer_user_team_pb.ResendInvitationRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ResendInvitationResponse.deserializeBinary
  );

  resendInvitation(
    request: wt_svc_customer_user_team_pb.ResendInvitationRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ResendInvitationResponse>;

  resendInvitation(
    request: wt_svc_customer_user_team_pb.ResendInvitationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ResendInvitationResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ResendInvitationResponse>;

  resendInvitation(
    request: wt_svc_customer_user_team_pb.ResendInvitationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ResendInvitationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ResendInvitation',
        request,
        metadata || {},
        this.methodDescriptorResendInvitation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ResendInvitation',
    request,
    metadata || {},
    this.methodDescriptorResendInvitation);
  }

  methodDescriptorCancelInvitation = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/CancelInvitation',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.CancelInvitationRequest,
    wt_svc_customer_user_team_pb.CancelInvitationResponse,
    (request: wt_svc_customer_user_team_pb.CancelInvitationRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.CancelInvitationResponse.deserializeBinary
  );

  cancelInvitation(
    request: wt_svc_customer_user_team_pb.CancelInvitationRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.CancelInvitationResponse>;

  cancelInvitation(
    request: wt_svc_customer_user_team_pb.CancelInvitationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelInvitationResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.CancelInvitationResponse>;

  cancelInvitation(
    request: wt_svc_customer_user_team_pb.CancelInvitationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelInvitationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/CancelInvitation',
        request,
        metadata || {},
        this.methodDescriptorCancelInvitation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/CancelInvitation',
    request,
    metadata || {},
    this.methodDescriptorCancelInvitation);
  }

  methodDescriptorSuggestTeams = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/SuggestTeams',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.SuggestTeamsRequest,
    wt_svc_customer_user_team_pb.SuggestTeamsResponse,
    (request: wt_svc_customer_user_team_pb.SuggestTeamsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.SuggestTeamsResponse.deserializeBinary
  );

  suggestTeams(
    request: wt_svc_customer_user_team_pb.SuggestTeamsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.SuggestTeamsResponse>;

  suggestTeams(
    request: wt_svc_customer_user_team_pb.SuggestTeamsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SuggestTeamsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.SuggestTeamsResponse>;

  suggestTeams(
    request: wt_svc_customer_user_team_pb.SuggestTeamsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.SuggestTeamsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/SuggestTeams',
        request,
        metadata || {},
        this.methodDescriptorSuggestTeams,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/SuggestTeams',
    request,
    metadata || {},
    this.methodDescriptorSuggestTeams);
  }

  methodDescriptorRequestToJoinTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/RequestToJoinTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.RequestToJoinTeamRequest,
    wt_svc_customer_user_team_pb.RequestToJoinTeamResponse,
    (request: wt_svc_customer_user_team_pb.RequestToJoinTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.RequestToJoinTeamResponse.deserializeBinary
  );

  requestToJoinTeam(
    request: wt_svc_customer_user_team_pb.RequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.RequestToJoinTeamResponse>;

  requestToJoinTeam(
    request: wt_svc_customer_user_team_pb.RequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.RequestToJoinTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.RequestToJoinTeamResponse>;

  requestToJoinTeam(
    request: wt_svc_customer_user_team_pb.RequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.RequestToJoinTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/RequestToJoinTeam',
        request,
        metadata || {},
        this.methodDescriptorRequestToJoinTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/RequestToJoinTeam',
    request,
    metadata || {},
    this.methodDescriptorRequestToJoinTeam);
  }

  methodDescriptorListMyPendingTeamJoinRequests = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ListMyPendingTeamJoinRequests',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsRequest,
    wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse,
    (request: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse.deserializeBinary
  );

  listMyPendingTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse>;

  listMyPendingTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse>;

  listMyPendingTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListMyPendingTeamJoinRequestsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ListMyPendingTeamJoinRequests',
        request,
        metadata || {},
        this.methodDescriptorListMyPendingTeamJoinRequests,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ListMyPendingTeamJoinRequests',
    request,
    metadata || {},
    this.methodDescriptorListMyPendingTeamJoinRequests);
  }

  methodDescriptorResendRequestToJoinTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ResendRequestToJoinTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ResendRequestToJoinTeamRequest,
    wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse,
    (request: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse.deserializeBinary
  );

  resendRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse>;

  resendRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse>;

  resendRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ResendRequestToJoinTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ResendRequestToJoinTeam',
        request,
        metadata || {},
        this.methodDescriptorResendRequestToJoinTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ResendRequestToJoinTeam',
    request,
    metadata || {},
    this.methodDescriptorResendRequestToJoinTeam);
  }

  methodDescriptorCancelMyRequestToJoinTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/CancelMyRequestToJoinTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamRequest,
    wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse,
    (request: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse.deserializeBinary
  );

  cancelMyRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse>;

  cancelMyRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse>;

  cancelMyRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelMyRequestToJoinTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/CancelMyRequestToJoinTeam',
        request,
        metadata || {},
        this.methodDescriptorCancelMyRequestToJoinTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/CancelMyRequestToJoinTeam',
    request,
    metadata || {},
    this.methodDescriptorCancelMyRequestToJoinTeam);
  }

  methodDescriptorListTeamJoinRequests = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ListTeamJoinRequests',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ListTeamJoinRequestsRequest,
    wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse,
    (request: wt_svc_customer_user_team_pb.ListTeamJoinRequestsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse.deserializeBinary
  );

  listTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse>;

  listTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse>;

  listTeamJoinRequests(
    request: wt_svc_customer_user_team_pb.ListTeamJoinRequestsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamJoinRequestsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ListTeamJoinRequests',
        request,
        metadata || {},
        this.methodDescriptorListTeamJoinRequests,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ListTeamJoinRequests',
    request,
    metadata || {},
    this.methodDescriptorListTeamJoinRequests);
  }

  methodDescriptorApproveRequestToJoinTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ApproveRequestToJoinTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamRequest,
    wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse,
    (request: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse.deserializeBinary
  );

  approveRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse>;

  approveRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse>;

  approveRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ApproveRequestToJoinTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ApproveRequestToJoinTeam',
        request,
        metadata || {},
        this.methodDescriptorApproveRequestToJoinTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ApproveRequestToJoinTeam',
    request,
    metadata || {},
    this.methodDescriptorApproveRequestToJoinTeam);
  }

  methodDescriptorDeclineRequestToJoinTeam = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/DeclineRequestToJoinTeam',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamRequest,
    wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse,
    (request: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse.deserializeBinary
  );

  declineRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse>;

  declineRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse>;

  declineRequestToJoinTeam(
    request: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeclineRequestToJoinTeamResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/DeclineRequestToJoinTeam',
        request,
        metadata || {},
        this.methodDescriptorDeclineRequestToJoinTeam,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/DeclineRequestToJoinTeam',
    request,
    metadata || {},
    this.methodDescriptorDeclineRequestToJoinTeam);
  }

  methodDescriptorListTeamMemberships = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ListTeamMemberships',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ListTeamMembershipsRequest,
    wt_svc_customer_user_team_pb.ListTeamMembershipsResponse,
    (request: wt_svc_customer_user_team_pb.ListTeamMembershipsRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ListTeamMembershipsResponse.deserializeBinary
  );

  listTeamMemberships(
    request: wt_svc_customer_user_team_pb.ListTeamMembershipsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ListTeamMembershipsResponse>;

  listTeamMemberships(
    request: wt_svc_customer_user_team_pb.ListTeamMembershipsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamMembershipsResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ListTeamMembershipsResponse>;

  listTeamMemberships(
    request: wt_svc_customer_user_team_pb.ListTeamMembershipsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListTeamMembershipsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ListTeamMemberships',
        request,
        metadata || {},
        this.methodDescriptorListTeamMemberships,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ListTeamMemberships',
    request,
    metadata || {},
    this.methodDescriptorListTeamMemberships);
  }

  methodDescriptorUpdateTeamMembership = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UpdateTeamMembership',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UpdateTeamMembershipRequest,
    wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse,
    (request: wt_svc_customer_user_team_pb.UpdateTeamMembershipRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse.deserializeBinary
  );

  updateTeamMembership(
    request: wt_svc_customer_user_team_pb.UpdateTeamMembershipRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse>;

  updateTeamMembership(
    request: wt_svc_customer_user_team_pb.UpdateTeamMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse>;

  updateTeamMembership(
    request: wt_svc_customer_user_team_pb.UpdateTeamMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateTeamMembershipResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UpdateTeamMembership',
        request,
        metadata || {},
        this.methodDescriptorUpdateTeamMembership,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UpdateTeamMembership',
    request,
    metadata || {},
    this.methodDescriptorUpdateTeamMembership);
  }

  methodDescriptorCancelMembership = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/CancelMembership',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.CancelMembershipRequest,
    wt_svc_customer_user_team_pb.CancelMembershipResponse,
    (request: wt_svc_customer_user_team_pb.CancelMembershipRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.CancelMembershipResponse.deserializeBinary
  );

  cancelMembership(
    request: wt_svc_customer_user_team_pb.CancelMembershipRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.CancelMembershipResponse>;

  cancelMembership(
    request: wt_svc_customer_user_team_pb.CancelMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelMembershipResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.CancelMembershipResponse>;

  cancelMembership(
    request: wt_svc_customer_user_team_pb.CancelMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CancelMembershipResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/CancelMembership',
        request,
        metadata || {},
        this.methodDescriptorCancelMembership,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/CancelMembership',
    request,
    metadata || {},
    this.methodDescriptorCancelMembership);
  }

  methodDescriptorActivateMembership = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ActivateMembership',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ActivateMembershipRequest,
    wt_svc_customer_user_team_pb.ActivateMembershipResponse,
    (request: wt_svc_customer_user_team_pb.ActivateMembershipRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ActivateMembershipResponse.deserializeBinary
  );

  activateMembership(
    request: wt_svc_customer_user_team_pb.ActivateMembershipRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ActivateMembershipResponse>;

  activateMembership(
    request: wt_svc_customer_user_team_pb.ActivateMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ActivateMembershipResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ActivateMembershipResponse>;

  activateMembership(
    request: wt_svc_customer_user_team_pb.ActivateMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ActivateMembershipResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ActivateMembership',
        request,
        metadata || {},
        this.methodDescriptorActivateMembership,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ActivateMembership',
    request,
    metadata || {},
    this.methodDescriptorActivateMembership);
  }

  methodDescriptorForgetTeamMember = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ForgetTeamMember',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ForgetTeamMemberRequest,
    wt_svc_customer_user_team_pb.ForgetTeamMemberResponse,
    (request: wt_svc_customer_user_team_pb.ForgetTeamMemberRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ForgetTeamMemberResponse.deserializeBinary
  );

  forgetTeamMember(
    request: wt_svc_customer_user_team_pb.ForgetTeamMemberRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ForgetTeamMemberResponse>;

  forgetTeamMember(
    request: wt_svc_customer_user_team_pb.ForgetTeamMemberRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ForgetTeamMemberResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ForgetTeamMemberResponse>;

  forgetTeamMember(
    request: wt_svc_customer_user_team_pb.ForgetTeamMemberRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ForgetTeamMemberResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ForgetTeamMember',
        request,
        metadata || {},
        this.methodDescriptorForgetTeamMember,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ForgetTeamMember',
    request,
    metadata || {},
    this.methodDescriptorForgetTeamMember);
  }

  methodDescriptorInvokeRightToBeForgotten = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/InvokeRightToBeForgotten',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.InvokeRightToBeForgottenRequest,
    wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse,
    (request: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse.deserializeBinary
  );

  invokeRightToBeForgotten(
    request: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse>;

  invokeRightToBeForgotten(
    request: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse>;

  invokeRightToBeForgotten(
    request: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.InvokeRightToBeForgottenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/InvokeRightToBeForgotten',
        request,
        metadata || {},
        this.methodDescriptorInvokeRightToBeForgotten,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/InvokeRightToBeForgotten',
    request,
    metadata || {},
    this.methodDescriptorInvokeRightToBeForgotten);
  }

  methodDescriptorUpdateAuthority = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UpdateAuthority',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UpdateAuthorityRequest,
    wt_svc_customer_user_team_pb.UpdateAuthorityResponse,
    (request: wt_svc_customer_user_team_pb.UpdateAuthorityRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UpdateAuthorityResponse.deserializeBinary
  );

  updateAuthority(
    request: wt_svc_customer_user_team_pb.UpdateAuthorityRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UpdateAuthorityResponse>;

  updateAuthority(
    request: wt_svc_customer_user_team_pb.UpdateAuthorityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateAuthorityResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UpdateAuthorityResponse>;

  updateAuthority(
    request: wt_svc_customer_user_team_pb.UpdateAuthorityRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateAuthorityResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UpdateAuthority',
        request,
        metadata || {},
        this.methodDescriptorUpdateAuthority,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UpdateAuthority',
    request,
    metadata || {},
    this.methodDescriptorUpdateAuthority);
  }

  methodDescriptorListBusinessRoles = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/ListBusinessRoles',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.ListBusinessRolesRequest,
    wt_svc_customer_user_team_pb.ListBusinessRolesResponse,
    (request: wt_svc_customer_user_team_pb.ListBusinessRolesRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.ListBusinessRolesResponse.deserializeBinary
  );

  listBusinessRoles(
    request: wt_svc_customer_user_team_pb.ListBusinessRolesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.ListBusinessRolesResponse>;

  listBusinessRoles(
    request: wt_svc_customer_user_team_pb.ListBusinessRolesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListBusinessRolesResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.ListBusinessRolesResponse>;

  listBusinessRoles(
    request: wt_svc_customer_user_team_pb.ListBusinessRolesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.ListBusinessRolesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/ListBusinessRoles',
        request,
        metadata || {},
        this.methodDescriptorListBusinessRoles,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/ListBusinessRoles',
    request,
    metadata || {},
    this.methodDescriptorListBusinessRoles);
  }

  methodDescriptorCreateBusinessRole = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/CreateBusinessRole',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.CreateBusinessRoleRequest,
    wt_svc_customer_user_team_pb.CreateBusinessRoleResponse,
    (request: wt_svc_customer_user_team_pb.CreateBusinessRoleRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.CreateBusinessRoleResponse.deserializeBinary
  );

  createBusinessRole(
    request: wt_svc_customer_user_team_pb.CreateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.CreateBusinessRoleResponse>;

  createBusinessRole(
    request: wt_svc_customer_user_team_pb.CreateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CreateBusinessRoleResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.CreateBusinessRoleResponse>;

  createBusinessRole(
    request: wt_svc_customer_user_team_pb.CreateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.CreateBusinessRoleResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/CreateBusinessRole',
        request,
        metadata || {},
        this.methodDescriptorCreateBusinessRole,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/CreateBusinessRole',
    request,
    metadata || {},
    this.methodDescriptorCreateBusinessRole);
  }

  methodDescriptorUpdateBusinessRole = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/UpdateBusinessRole',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.UpdateBusinessRoleRequest,
    wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse,
    (request: wt_svc_customer_user_team_pb.UpdateBusinessRoleRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse.deserializeBinary
  );

  updateBusinessRole(
    request: wt_svc_customer_user_team_pb.UpdateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse>;

  updateBusinessRole(
    request: wt_svc_customer_user_team_pb.UpdateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse>;

  updateBusinessRole(
    request: wt_svc_customer_user_team_pb.UpdateBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.UpdateBusinessRoleResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/UpdateBusinessRole',
        request,
        metadata || {},
        this.methodDescriptorUpdateBusinessRole,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/UpdateBusinessRole',
    request,
    metadata || {},
    this.methodDescriptorUpdateBusinessRole);
  }

  methodDescriptorDeleteBusinessRole = new grpcWeb.MethodDescriptor(
    '/pi_customer_public.UserTeamService/DeleteBusinessRole',
    grpcWeb.MethodType.UNARY,
    wt_svc_customer_user_team_pb.DeleteBusinessRoleRequest,
    wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse,
    (request: wt_svc_customer_user_team_pb.DeleteBusinessRoleRequest) => {
      return request.serializeBinary();
    },
    wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse.deserializeBinary
  );

  deleteBusinessRole(
    request: wt_svc_customer_user_team_pb.DeleteBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null): Promise<wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse>;

  deleteBusinessRole(
    request: wt_svc_customer_user_team_pb.DeleteBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse) => void): grpcWeb.ClientReadableStream<wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse>;

  deleteBusinessRole(
    request: wt_svc_customer_user_team_pb.DeleteBusinessRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wt_svc_customer_user_team_pb.DeleteBusinessRoleResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pi_customer_public.UserTeamService/DeleteBusinessRole',
        request,
        metadata || {},
        this.methodDescriptorDeleteBusinessRole,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pi_customer_public.UserTeamService/DeleteBusinessRole',
    request,
    metadata || {},
    this.methodDescriptorDeleteBusinessRole);
  }

}

